// Copyright (c) 2020 Deere & Company

import actions from '../../action-list';

export const updateTemporaryObjectKey = temporaryObjectKey =>

    dispatch => {

        dispatch({
            temporaryObjectKey,
            type: actions.UPDATE_CLAIM_BATTERY_TEMPORARY_OBJECT_KEY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/update-temporary-object-key.js